
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.971","height":"16.97"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"croix","transform":"translate(-586.015 -475.015)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Ligne_14","d":"M0 0h20","data-name":"Ligne 14","transform":"rotate(-45 885.886 -463.804)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Ligne_15","d":"M0 0h20","data-name":"Ligne 15","transform":"rotate(-135 402.386 120.696)"}})])])
          )
        }
      }
    